// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_bj-b";
export var colorBlue = "_bj-8";
export var colorDot = "_bj-0";
export var colorDotLarge = "_bj-2";
export var colorDotSmall = "_bj-1";
export var colorGreen = "_bj-7";
export var colorGrey = "_bj-3";
export var colorOrange = "_bj-5";
export var colorPink = "_bj-a";
export var colorPurple = "_bj-9";
export var colorRed = "_bj-4";
export var colorYellow = "_bj-6";